import Http from "./Http";

export class MessagesService extends Http {
  /**
   * Delete message by id
   * @param {number} id
   */
  deleteMessage(id) {
    return this.delete(`/messages/${id}`);
  }

  /**
   * Update message
   * @param {number} id
   * @param {Object} body
   * @param {string} body.text
   */
  editMessage(id, body) {
    return this.put(`/messages/${id}`, body);
  }
}

export default new MessagesService();
